<app-table [data]="toolsGrouped"
           [config]="tableConfig"
           [treeMode]="true"
           [rowExpand]="true"
           [isLoading]="isLoading"
           [showFilters]="showFilters"
           [showGroupFilters]="showGroupFilters"
           [showGroupers]="showGroupers"
           [definedGroupers]="definedGroupers"
           [groupableColumns]="groupableColumns"
           [isFilterExpanded]="isFilterExpanded"
           [hasPagination]="showPagination"
           [filtersToggle] = "filtersToggle"
           [directlyGrouped]="true"
           [displayToggleFilters]="false"
           [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
           [hasTitle]="false"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (filterGroupChange)="onFilterGroupChange($event)"
           (groupChange)="onGroupChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column header="{{'admin.tools.table.columns.toolName' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.toolName' | translate}}"
                      sortable="true"
                      filter="true"
                      [showTree]="true"
                      field="name">
        <ng-template #body let-record="record">
            <div class="tool-select">
                <input type="checkbox"
                       (click)="onClickTool($event, record)"
                       *ngIf="hasCheckbox(record)"
                       [checked]="isChecked(record)"
                       [disabled]="isSelectionDisabled(record)"/>
                <span>{{record?.name}}</span>
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.toolUid' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.toolUid' | translate}}"
                      sortable="true"
                      filter="true"
                      field="toolUid">
        <ng-template #body
                     let-record="record">
            <div [class.tool-set]="isToolSet(record)">
                {{isToolSet(record) ? 'SET' : record?.toolUid}}
            </div>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.tools.table.columns.toolLine' | translate}}"
                      filterPlaceholder="{{'admin.tools.table.filters.toolLine' | translate}}"
                      sortable="true"
                      filter="true"
                      field="line">
        <ng-template #body
                     let-record="record">
            {{record?.mainLine?.name}}
        </ng-template>
    </app-table-column>
</app-table>
